import React from "react";

// スタイルインポート
import "../../pages/css/works.scss";
import "../../responsive/WorksResponsive.scss";
import "../../common.scss";

// 縦線
import line from "../../img/services/Rectangle.svg";

// 制作事例01
import work01 from "../../img/works/ec-works.jpg";
import work02 from "../../img/works/insurance-works.jpg";

function PortfolioList() {
    return (
        <>
            <section className="wrk-main-sec">
                <div className="wrk-img">
                    <img loading="lazy" src={work01} alt="" />
                </div>
                <div className="wrk-ttl">ファッション通販サイト</div>
                <div className="wrk-desc">
                    ファッション通販サイトの実装業務を担当させていただきました。
                    他のパートナー会社と連携を取りながら、随時通販サイトの更新をさせていただきました。
                </div>
                <table border="1" class="wrk-table">
                    <tr>
                        <td>種類</td>
                        <td>ECサイト</td>
                    </tr>
                    <tr>
                        <td>参考URL</td>
                        <td>
                            <a
                                href="https://www.gu-global.com/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                https://www.gu-global.com/
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>担当</td>
                        <td>
                            <dl>
                                <dt>コーディング</dt>
                                <dd>SmartGenz</dd>
                                <dt>WordPress実装</dt>
                                <dd>なし</dd>
                                <dt>バックエンド</dt>
                                <dd>パートナー会社</dd>
                            </dl>
                        </td>
                    </tr>
                </table>
            </section>
            <section className="wrk-main-sec">
                <div className="wrk-img">
                    <img src={work02} alt="" />
                </div>
                <div className="wrk-ttl">大手保険会社</div>
                <div className="wrk-desc">
                    大手保険会社（公式サイト）の実装業務を担当させていただきました。
                    他のパートナー会社と連携を取りながら、随時ホームページの実装をさせていただきました。
                </div>
                <table border="1" class="wrk-table">
                    <tr>
                        <td>種類</td>
                        <td>オンライン保険サイト</td>
                    </tr>
                    <tr>
                        <td>URL</td>
                        <td>
                            <a
                                href="https://www.sumitomolife.co.jp/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                https://www.sumitomolife.co.jp/
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <td>担当</td>
                        <td>
                            <dl>
                                <dt>コーディング</dt>
                                <dd>SmartGenz</dd>
                                <dt>WordPress実装</dt>
                                <dd>なし</dd>
                                <dt>バックエンド</dt>
                                <dd>パートナー会社</dd>
                            </dl>
                        </td>
                    </tr>
                </table>
            </section>
        </>
    );
}
export default PortfolioList;
